import storeUser from '@/store/user';
import UserService from '@/service/user/user';

const LOGIN_PATH = '/login';
const HOME_PATH = '/';

class AuthMiddleware {

  async actions(next, permissionsRoute) {
    const { status } = await UserService.authenticate();

    if (status !== 200) {
      return next(LOGIN_PATH);
    }

    if (permissionsRoute) {
      if (!storeUser.state.data.profile && sessionStorage.getItem('token')) {
        await storeUser.dispatch('user/fetch');
      }

      const profile = storeUser.state.data.profile;

      if (!profile || !profile.permissions) {
        return next(LOGIN_PATH);
      }

      const hasPermission = profile.permissions.some(p => p === permissionsRoute);

      if (!hasPermission) {
        return next(LOGIN_PATH);
      }
    }

    return next();
  }

  async execute(to, from, next) {
  const token = sessionStorage.getItem('token');
  const isLoginPage = to.name === 'login';
  const isPublicRoute = ['forgot-password', 'reset-password', 'verify-code'].includes(to.name);

  if (!token && !isLoginPage && !isPublicRoute) {
    localStorage.setItem('redirectAfterLogin', to.fullPath);
    return next({ name: 'login' });
  }

if (isLoginPage && token) {
  try {
    const { status } = await UserService.authenticate();

    if (status === 200) {
      const redirect = localStorage.getItem('redirectAfterLogin') || HOME_PATH;
      localStorage.removeItem('redirectAfterLogin');
      return next(redirect);
    }

    if (status === 423) {
      sessionStorage.removeItem('token');
      return next();
    }

    sessionStorage.removeItem('token');
    return next();

  } catch {
    sessionStorage.removeItem('token');
    return next();
  }
}

  if (isPublicRoute || isLoginPage) {
    return next();
  }

  let permissionsRoute = null;
  const routeWithPermission = to.matched.find(r => r.meta && r.meta.permissions);

  if (routeWithPermission?.meta) {
    permissionsRoute = routeWithPermission.meta.permissions;
  }

  try {
    if (!storeUser.state.data.profile && token) {
      await storeUser.dispatch('user/fetch');
    }

    return this.actions(next, permissionsRoute);
  } catch (e) {
    localStorage.setItem('redirectAfterLogin', to.fullPath);
    return next({ name: 'login' });
   }
  }
}

export default new AuthMiddleware();
